import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";

function Guide() {
  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2" />
      </main>
    </>
  );
}

export default Guide;
